import { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import { TostMsg } from "../../../App";

function OrgnizationTeam() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [hirechyData, setHirechyData] = useState([]);
  const { showLoading, hideLoading } = useContext(LoaderContext);
  const [employeTeamData, setEmployeTeamData] = useState([]);
  const [employeObserverData, setEmployeObserverData] = useState([]);
  const [reportingHirechy, setReportingHirechy] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let OrganizationId = userDetails?.OrgKeyValues.filter((item) => item?.Name === "EmployeeIdAtTopInHierarchy");
    let OrgSuperId = OrganizationId[0]?.InferredValue;
    getTeamMemberListOfEmployee(OrgSuperId);
    ReportOrHierarchy(OrgSuperId);
  }, []);

  async function getTeamMemberListOfEmployee(orgEmpId) {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 2,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: Number(orgEmpId),
    };
    try {
      let employeesList = await getEmployeeList(params);
      const employeesTeamListData = employeesList.Data || [];
      setEmployeObserverData(employeesTeamListData);
    } catch (error) {}
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function ReportOrHierarchy(data) {
    let EmpId = Number(data);
    if (data?.Id) {
      setHirechyData((prev) => {
        const existsIndex = prev.findIndex((item) => item.EmpId === data.EmpId);
        if (existsIndex !== -1) {
          return prev.slice(0, existsIndex + 1);
        }
        return [...prev, data];
      });
      EmpId = data?.Id;
    } else if (employeObserverData[0]?.OverseerId) {
      setHirechyData((prevValues) => []);
      EmpId = employeObserverData[0]?.OverseerId;
    } else {
      setHirechyData((prevValues) => []);
      EmpId = Number(data);
    }
    var params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 2,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: EmpId,
      IsSuggestedOnly: 0,
    };
    setIsLoading(true);
    try {
      showLoading();
      let employeesHierarchyList = await getEmployeeList(params1);
      setReportingHirechy(
        employeesHierarchyList.Data?.sort(
          (a, b) => b?.DirectReporteeCount - a?.DirectReporteeCount
        )
      );
      hideLoading();
      setIsLoading(false);
    } catch (error) {
      hideLoading();
      setIsLoading(false);
    }
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
        <div className="documentdiv">
          <div className="">
            <div className="timeline-div">
              <h2 className="text-primary mb-3 sumh4 info-type-heading org-font">
                Organization Chart{" "} ({userDetails?.OrganizationName})
              </h2>
              <div className="timeline">
                {employeObserverData[0]?.OverseerName ? (
                  <div
                    className="timeline-month"
                    style={{ cursor: "pointer" }}
                    onClick={() => ReportOrHierarchy(0)}
                  >
                    <img
                      src={employeObserverData[0]?.OverseerImage || defaultImage}
                      onError={handleImageError}
                    />

                    <p>{employeObserverData[0]?.OverseerName}</p>
                    <p className="designation">
                      {" "}
                      {employeObserverData[0]?.OverseerDesignation}
                    </p>
                  </div>
                ) : (
                  <div
                    className="timeline-month"
                    style={{ cursor: "pointer" }}
                    onClick={() => ReportOrHierarchy()}
                  >
                    <img
                      src={employeObserverData[0]?.ProfileImage || defaultImage}
                      onError={handleImageError}
                    />
                    <div>
                      <p>{employeObserverData[0]?.FullName}</p>
                      <p className="designation">
                        
                        {employeObserverData[0]?.CurrentDesignation}
                      </p>
                    </div>
                  </div>
                )}
                {hirechyData?.map((item) => (
                  <div
                    className="timeline-month"
                    style={{ cursor: "pointer" }}
                    onClick={() => ReportOrHierarchy(item)}
                  >
                    {" "}
                    <img
                      src={item?.ProfileImage || defaultImage}
                      onError={handleImageError}
                    />
                    <p>{item?.FullName}</p>
                    <p className="designation"> {item?.CurrentDesignation}</p>
                  </div>
                ))}
                <div className="timeline-section">
                  {hirechyData && (
                    <div className="timeline-date w-time">
                      <p className="mb-0">
                        Direct Reports - {reportingHirechy?.length}
                      </p>
                    </div>
                  )}
                  {reportingHirechy?.length > 0 && (
                    <div
                      className="row"
                      style={{
                        background: "white",
                        padding: "1rem 0",
                      }}
                    >
                      {reportingHirechy?.map((report, index) => {
                        return (
                          <div key={index} className="divide-div">
                            <div
                              className="timeline-box"
                              style={{ cursor: "pointer" }}
                              onClick={() => ReportOrHierarchy(report)}
                            >
                              <div className="box-content">
                                <div class="info-tooltip-area">
                                  {
                                    <img
                                      src={report?.ProfileImage || defaultImage}
                                      onError={handleImageError}
                                    />
                                  }
                                  <div class="info-tooltip-content">
                                    <div class="purchase-tooltip-content">
                                      <div className="user-info">
                                        <div className="d-flex align-items-start">
                                          <img
                                            src={
                                              report?.ProfileImage || defaultImage
                                            }
                                            className="me-1"
                                            onError={handleImageError}
                                          />
                                          <div className="userdetail-tooltip">
                                            <strong>{report?.FullName}</strong>
                                            <span>
                                              {report?.CurrentDesignation}
                                            </span>
                                            {report?.DirectReporteeCount != 0 ? (
                                              <p>
                                                Member Count -{" "}
                                                <span className="count">
                                                  {report?.DirectReporteeCount}
                                                </span>
                                              </p>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                        <ul>
                                          {report?.UserName && (
                                            <li>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                class="bi bi-envelope"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                                              </svg>{" "}
                                              <span>{report?.UserName}</span>
                                            </li>
                                          )}
                                          {report?.PhoneNumber && (
                                            <li>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="16"
                                                fill="currentColor"
                                                class="bi bi-phone"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                                                <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                              </svg>
                                              <span>{report?.PhoneNumber}</span>
                                            </li>
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="box-item">
                                  <strong>{report?.FullName}</strong>
                                  <span>{report?.CurrentDesignation}</span>
                                  <div className="team-report-info ">
                                    {report?.DirectReporteeCount != 0 ? (
                                      <p>
                                        <span className="img-team-report">
                                          <img src="/images/menu-icon/quick-action/emp/3.png" />
                                        </span>
                                        <span className="count">
                                          {report?.DirectReporteeCount}
                                        </span>
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <Suspense>
              <ComponentLoader />
            </Suspense>
          ) : (
            ""
          )}
        </div>
        </div>
      </div>
    </div>
  );
}
export default OrgnizationTeam;
